// src/containers/homepage/projectsData.js

import User1Img from "../../assets/pictures/1b.jpg";
import User2Img from "../../assets/pictures/dziury.jpg";
import User3Img from "../../assets/pictures/3b.jpg";
import User4Img from "../../assets/pictures/4b.jpg";
import User5Img from "../../assets/pictures/5b.jpg";
import User6Img from "../../assets/pictures/ai.jpg";
import User7Img from "../../assets/pictures/podroze.jpg";
import User8Img from "../../assets/pictures/8b.jpg";
import User9Img from "../../assets/pictures/tent.jpg";
import User10Img from "../../assets/pictures/10b.jpg";
import User11Img from "../../assets/pictures/11b.jpg";
import User12Img from "../../assets/pictures/12b.jpg";
import User13Img from "../../assets/pictures/13b.jpg";
import User14Img from "../../assets/pictures/14b.jpg";
import User15Img from "../../assets/pictures/15b.jpg";
import User16Img from "../../assets/pictures/16b.jpg";
import User17Img from "../../assets/pictures/dom.jpg";
import User18Img from "../../assets/pictures/poetry.jpg";
import User19Img from "../../assets/pictures/solna.jpg";
import User20Img from "../../assets/pictures/17b.jpg";
import User21Img from "../../assets/pictures/ob.jpg";
import User22Img from "../../assets/pictures/mk.jpg";
import User23Img from "../../assets/pictures/mapa.jpg";
import User24Img from "../../assets/pictures/dino-b.jpg";
import User25Img from "../../assets/pictures/epi.jpg";
import User26Img from "../../assets/pictures/sara.jpg";
import User27Img from "../../assets/pictures/zamki-b.jpg";
import User28Img from "../../assets/pictures/pralnia-b.jpg";
import User29Img from "../../assets/pictures/moj-jezus.jpg";
import User30Img from "../../assets/pictures/faustyna.jpg";
import User31Img from "../../assets/pictures/magnus-ab.jpg";
import User32Img from "../../assets/pictures/matejko.jpg";
import User33Img from "../../assets/pictures/library.jpg";
import User34Img from "../../assets/pictures/holmes.jpg";
import User35Img from "../../assets/pictures/starcy.jpg";
import User36Img from "../../assets/pictures/heller.jpg";
import User37Img from "../../assets/pictures/woda.jpg";
import User38Img from "../../assets/pictures/17.jpg";
import User39Img from "../../assets/pictures/mak.jpg";
import User40Img from "../../assets/pictures/plan.jpg";
import User41Img from "../../assets/pictures/praga.jpg";
import User42Img from "../../assets/pictures/gdansk.jpg";
import User43Img from "../../assets/pictures/perelman.jpg";
import User44Img from "../../assets/pictures/reagan.jpg";
import User45Img from "../../assets/pictures/wesele.jpg";
import User46Img from "../../assets/pictures/alkohol.jpg";
import User47Img from "../../assets/pictures/rosary.jpg";
import User48Img from "../../assets/pictures/zin.jpg";
import User49Img from "../../assets/pictures/tesla.jpg";
import User50Img from "../../assets/pictures/banach.jpg";
import User51Img from "../../assets/pictures/niepodl.jpg";
import User52Img from "../../assets/pictures/western.jpg";
import User53Img from "../../assets/pictures/aleksander.jpg";
import User54Img from "../../assets/pictures/rzym.jpg";
import User55Img from "../../assets/pictures/barok.jpg";
import User56Img from "../../assets/pictures/kochan.jpg";
import User57Img from "../../assets/pictures/oswiecenie.jpg";
import User58Img from "../../assets/pictures/romantyzm.jpg";
import User59Img from "../../assets/pictures/pozytywizm.jpg";
import User60Img from "../../assets/pictures/m.polska.jpg";
import User61Img from "../../assets/pictures/miedzy.jpg";
import User62Img from "../../assets/pictures/okup.jpg";
import User63Img from "../../assets/pictures/kmiecie.jpg";
import User64Img from "../../assets/pictures/panszczyzna.jpg";
import User65Img from "../../assets/pictures/anne.jpg";
import User66Img from "../../assets/pictures/zloto.jpg";
import User67Img from "../../assets/pictures/glogier.jpg";
import User68Img from "../../assets/pictures/dalajlama.jpg";
import User69Img from "../../assets/pictures/potop.jpg";
import User70Img from "../../assets/pictures/penrose.jpg";
import User71Img from "../../assets/pictures/arka.jpg";
import User72Img from "../../assets/pictures/chopin.jpg";
import User73Img from "../../assets/pictures/pickwick.jpg";
import User74Img from "../../assets/pictures/menuhin.jpg";
import User75Img from "../../assets/pictures/kowalewski.jpg";
import User76Img from "../../assets/pictures/zdanowska.jpg";
import User77Img from "../../assets/pictures/zelenski.jpg";
import User78Img from "../../assets/pictures/zbrodnie.jpg";
import User79Img from "../../assets/pictures/ofiary.jpg";
import User80Img from "../../assets/pictures/stop-putin.jpg";
import User81Img from "../../assets/pictures/krzyz.jpg";
import User82Img from "../../assets/pictures/skrzypek.jpg";
import User83Img from "../../assets/pictures/edyp.jpg";
import User84Img from "../../assets/pictures/konstytucja.jpg";
import User85Img from "../../assets/pictures/mazurzyn.jpg";
import User86Img from "../../assets/pictures/trela.jpg";
import User87Img from "../../assets/pictures/asperger.jpg";
import User88Img from "../../assets/pictures/elzbietanki.jpg";
import User89Img from "../../assets/pictures/nataniel.jpg";
import User90Img from "../../assets/pictures/aktywny.jpg";
import User91Img from "../../assets/pictures/kaku.jpg";
import User92Img from "../../assets/pictures/wolyn.jpg";
import User93Img from "../../assets/pictures/stanko.jpg";
import User94Img from "../../assets/pictures/herbert.jpg";
import User95Img from "../../assets/pictures/turing.jpg";
import User96Img from "../../assets/pictures/bog.jpg";
import User97Img from "../../assets/pictures/jennifer.jpg";
import User98Img from "../../assets/pictures/elzbieta.jpg";
import User99Img from "../../assets/pictures/kosz.jpg";
import User100Img from "../../assets/pictures/sidis.jpg";
import User101Img from "../../assets/pictures/rodzinnie.jpg";
import User102Img from "../../assets/pictures/kobiela.jpg";
import User103Img from "../../assets/pictures/falski.jpg";
import User104Img from "../../assets/pictures/korepetycje.jpg";
import User105Img from "../../assets/pictures/ania.jpg";
import User106Img from "../../assets/pictures/habitat.jpg";
import User107Img from "../../assets/pictures/blog-natanka.jpg";
import User108Img from "../../assets/pictures/wartosci.jpg";
import User109Img from "../../assets/pictures/niedzwiecki.jpg";
import User110Img from "../../assets/pictures/natek.jpg";
import User111Img from "../../assets/pictures/nat.jpg";
import User112Img from "../../assets/pictures/dobrowolski.jpg";
import User113Img from "../../assets/pictures/namioty.jpg";
import User114Img from "../../assets/pictures/prorocy.jpg";
import User115Img from "../../assets/pictures/jacek.jpg";
import User116Img from "../../assets/pictures/aqua.jpg";
import User117Img from "../../assets/pictures/mosiolek.jpg";
import User118Img from "../../assets/pictures/eurotrek.jpg";
import User119Img from "../../assets/pictures/poplawski.jpg";
import User120Img from "../../assets/pictures/pucus.jpg";
import User121Img from "../../assets/pictures/rod.jpg";
import User122Img from "../../assets/pictures/rutkowski.jpg";
import User123Img from "../../assets/pictures/zbuduj.jpg";
import User124Img from "../../assets/pictures/kwanty.jpg";
import User125Img from "../../assets/pictures/akademia.jpg";
import User126Img from "../../assets/pictures/thonet.jpg";
import User127Img from "../../assets/pictures/antypowabne.jpg";
import User128Img from "../../assets/pictures/dunajski.jpg";
import User129Img from "../../assets/pictures/hawking.jpg";
import User130Img from "../../assets/pictures/aqua-plus.jpg";
import User131Img from "../../assets/pictures/konstelacja.jpg";
import User132Img from "../../assets/pictures/ewangelie.jpg";
import User133Img from "../../assets/pictures/korki.jpg";
import User134Img from "../../assets/pictures/swieci.jpg";
import User135Img from "../../assets/pictures/kuchnia.jpg";
import User136Img from "../../assets/pictures/wielocha.jpg";
import User137Img from "../../assets/pictures/odnowa.jpg";
import User138Img from "../../assets/pictures/cichowska.jpg";
import User139Img from "../../assets/pictures/mmos.jpg";
import User140Img from "../../assets/pictures/julia.jpg";
import User141Img from "../../assets/pictures/logos.jpg";
import User142Img from "../../assets/pictures/proca.jpg";
import User143Img from "../../assets/pictures/klasa.jpg";
import User144Img from "../../assets/pictures/wolyn_.jpg";
import User145Img from "../../assets/pictures/wstrzas.jpg";
import User146Img from "../../assets/pictures/grunwald.jpg";
import User147Img from "../../assets/pictures/szafarnia.jpg";
import User148Img from "../../assets/pictures/naukap.jpg";
import User149Img from "../../assets/pictures/niezdecydowanie.jpg";
import User150Img from "../../assets/pictures/maryja.jpg";
import User151Img from "../../assets/pictures/kotlet.jpg";
import User152Img from "../../assets/pictures/minda.jpg";
import User153Img from "../../assets/pictures/szuraniec.jpg";
import User154Img from "../../assets/pictures/pomoc.jpg";
import User155Img from "../../assets/pictures/natalia.jpg";
import User156Img from "../../assets/pictures/trener.jpg";

export const projects = [
  {
    img: User1Img,
    txt: "Słodkolandia wita:",
    user: "Firma eventowa",
    url: "//www.slodkolandia.cba.pl",
  },
  {
    img: User2Img,
    txt: "Czarne dziury",
    user: "Projekt edukacyjny",
    url: "//czarne-dziury.netlify.app",
  },
  {
    img: User3Img,
    txt: "Fontanny czekoladowe",
    user: "Firma eventowa",
    url: "//www.fontanny.slodkolandia.cba.pl",
  },
  {
    img: User4Img,
    txt: "Cytaty z Biblii",
    user: "Projekt prywatny",
    url: "//slowoboze.netlify.app",
  },
  {
    img: User5Img,
    txt: "Portfolio",
    user: "Projekt prywatny",
    url: "//parodysta.netlify.app",
  },
  {
    img: User6Img,
    txt: "Sztuczna Inteligencja",
    user: "AI",
    url: "//neural-core.netlify.app/",
  },
  {
    img: User7Img,
    txt: "Gosia i przyjaciele",
    user: "Projekt prywatny",
    url: "//podroze-gosi.netlify.app",
  },
  {
    img: User8Img,
    txt: "Roszada",
    user: "UKS Radom",
    url: "//www.roszada.radom.pl",
  },
  {
    img: User9Img,
    txt: "Namioty imprezowe",
    user: "Firma eventowa",
    url: "//namioty-imprezowe.netlify.app",
  },
  {
    img: User10Img,
    txt: "Brzoz-Med",
    user: "Basket Team",
    url: "//b-mbteam.netlify.app",
  },
  {
    img: User11Img,
    txt: "Ciasteczkowa Grama",
    user: "Szkoła językowa",
    url: "//grama.netlify.app",
  },
  {
    img: User12Img,
    txt: "Portfolio",
    user: "Projekt prywatny",
    url: "//komiks.netlify.app",
  },
  {
    img: User13Img,
    txt: "100 najlepszych firm w mieście",
    user: "Firma reklamowa",
    url: "//baza-firm.netlify.app",
  },
  {
    img: User14Img,
    txt: "Portfolio szachisty",
    user: "Projekt prywatny",
    url: "//wiktor-chess.netlify.app",
  },
  {
    img: User15Img,
    txt: "Portfolio parodysty",
    user: "Projekt prywatny",
    url: "//radomski-parodysta.netlify.app",
  },
  {
    img: User16Img,
    txt: "Resurrexit",
    user: "Grupa charyzmatyczna",
    url: "//resurrexit.netlify.app",
  },
  {
    img: User17Img,
    txt: "Domy i ludzie",
    user: "Projekt prywatny",
    url: "//czarna.netlify.app",
  },
  {
    img: User18Img,
    txt: "Wiersze antypowabne",
    user: "Projekt prywatny",
    url: "//poetry.netlify.app",
  },
  {
    img: User19Img,
    txt: "Dom na Solnej",
    user: "Projekt prywatny",
    url: "//solna.netlify.app",
  },
  {
    img: User20Img,
    txt: "Korzenie rodów Gierczak i Ofiara",
    user: "Projekt prywatny",
    url: "//korzenie.netlify.app",
  },
  {
    img: User21Img,
    txt: "Ognisko plastyczne",
    user: "Projekt prywatny",
    url: "//ognisko.netlify.app",
  },
  {
    img: User22Img,
    txt: "Monika Knapczyk",
    user: "Pisarka, wydawca, blogerka",
    url: "//m-knapczyk.netlify.app",
  },
  {
    img: User23Img,
    txt: "Mapa życiowa",
    user: "Projekt prywatny",
    url: "//droga.netlify.app",
  },
  {
    img: User24Img,
    txt: "Dinozaury Krystiana",
    user: "Projekt prywatny",
    url: "//dinozaury.netlify.app",
  },
  {
    img: User25Img,
    txt: "Epifaniusz Drowniak",
    user: "Projekt prywatny",
    url: "//nikifor.netlify.app",
  },
  {
    img: User26Img,
    txt: "Zuzanna Ginczanka",
    user: "Projekt prywatny",
    url: "//ginczanka.netlify.app",
  },
  {
    img: User27Img,
    txt: "Wynajem urządzeń rekreacyjnych",
    user: "Firma eventowa",
    url: "//zamki.netlify.app",
  },
  {
    img: User28Img,
    txt: "Pralnia stacjonarna i mobilna",
    user: "Firma usługowa",
    url: "//pranie-dywanow.netlify.app",
  },
  {
    img: User29Img,
    txt: "Mój Jezus",
    user: "Projekt prywatny",
    url: "//moj-jezus.netlify.app",
  },
  {
    img: User30Img,
    txt: "Św. Faustyna",
    user: "Projekt prywatny",
    url: "//faustyna.netlify.app",
  },
  {
    img: User31Img,
    txt: "Magnus Carlsen",
    user: "Projekt prywatny",
    url: "//carlsen.netlify.app",
  },
  {
    img: User32Img,
    txt: "Jan Matejko",
    user: "Projekt prywatny",
    url: "//matejko.netlify.app",
  },
  {
    img: User33Img,
    txt: "Biblioteka Aleksandryjska",
    user: "Projekt prywatny",
    url: "//aleksandryjska.netlify.app",
  },
  {
    img: User34Img,
    txt: "Sherlock Holmes",
    user: "Projekt prywatny",
    url: "//sherry-holmes.netlify.app",
  },
  {
    img: User35Img,
    txt: "Starcy",
    user: "Projekt prywatny",
    url: "//starcy.netlify.app",
  },
  {
    img: User36Img,
    txt: "Michał Heller",
    user: "Projekt prywatny",
    url: "//michal-heller.netlify.app",
  },
  {
    img: User37Img,
    txt: "Woda na Ziemi",
    user: "Projekt prywatny",
    url: "//oksydan.netlify.app",
  },
  {
    img: User38Img,
    txt: "Marianna i Józef",
    user: "Projekt prywatny",
    url: "//rodzice.netlify.app",
  },
  {
    img: User39Img,
    txt: "Tadeusz Makowski",
    user: "Projekt prywatny",
    url: "//tade.netlify.app",
  },
  {
    img: User40Img,
    txt: "Boży plan",
    user: "Projekt prywatny",
    url: "//bozyplan.netlify.app",
  },
  {
    img: User41Img,
    txt: "Praga",
    user: "Projekt prywatny",
    url: "//praga.netlify.app",
  },
  {
    img: User42Img,
    txt: "Gdańsk",
    user: "Projekt prywatny",
    url: "//gdanczk.netlify.app",
  },
  {
    img: User43Img,
    txt: "7 zagadek milenijnych",
    user: "Projekt prywatny",
    url: "//perelman.netlify.app",
  },
  {
    img: User44Img,
    txt: "Ronald Reagan",
    user: "Projekt prywatny",
    url: "//ronald-reagan.netlify.app",
  },
  {
    img: User45Img,
    txt: "Wesele Wyspiański",
    user: "Projekt edukacyjny",
    url: "//wyspianski.netlify.app",
  },
  {
    img: User46Img,
    txt: "Alkoholizm",
    user: "Projekt edukacyjny",
    url: "//alkoholizm.netlify.app",
  },
  {
    img: User47Img,
    txt: "Różaniec",
    user: "Projekt edukacyjny",
    url: "//rozaniec.netlify.app",
  },
  {
    img: User48Img,
    txt: "Piórkiem i węglem",
    user: "Projekt edukacyjny",
    url: "//wiktor-zin.netlify.app",
  },
  {
    img: User49Img,
    txt: "Nikola Tesla",
    user: "Projekt edukacyjny",
    url: "//n-t.netlify.app",
  },
  {
    img: User50Img,
    txt: "Stefan Banach",
    user: "Projekt edukacyjny",
    url: "//stefan-banach.netlify.app",
  },
  {
    img: User51Img,
    txt: "Niepodległa",
    user: "Projekt edukacyjny",
    url: "//niepodleglosc.netlify.app",
  },
  {
    img: User52Img,
    txt: "Western",
    user: "Projekt prywatny",
    url: "//dziki-zachod.netlify.app",
  },
  {
    img: User53Img,
    txt: "Aleksander Wielki",
    user: "Projekt edukacyjny",
    url: "//aleksander-wielki.netlify.app",
  },
  {
    img: User54Img,
    txt: "Starożytny Rzym",
    user: "Projekt edukacyjny",
    url: "//rzym.netlify.app",
  },
  {
    img: User55Img,
    txt: "Barok w literaturze",
    user: "Projekt edukacyjny",
    url: "//barok.netlify.app",
  },
  {
    img: User56Img,
    txt: "Renesans w literaturze",
    user: "Projekt edukacyjny",
    url: "//jan-kochanowski.netlify.app",
  },
  {
    img: User57Img,
    txt: "Oświecenie w literaturze",
    user: "Projekt edukacyjny",
    url: "//oswiecenie.netlify.app",
  },
  {
    img: User58Img,
    txt: "Romantyzm w literaturze",
    user: "Projekt edukacyjny",
    url: "//romantyzm.netlify.app",
  },
  {
    img: User59Img,
    txt: "Pozytywizm w literaturze",
    user: "Projekt edukacyjny",
    url: "//pozytywizm.netlify.app",
  },
  {
    img: User60Img,
    txt: "Młoda Polska w literaturze",
    user: "Projekt edukacyjny",
    url: "//mloda-polska.netlify.app",
  },
  {
    img: User61Img,
    txt: "Międzywojnie w literaturze",
    user: "Projekt edukacyjny",
    url: "//miedzywojnie.netlify.app",
  },
  {
    img: User62Img,
    txt: "Literatura okupacyjna",
    user: "Projekt edukacyjny",
    url: "//okupacja.netlify.app",
  },
  {
    img: User63Img,
    txt: "Wieś renesansowa",
    user: "Projekt edukacyjny",
    url: "//kmiecie.netlify.app",
  },
  {
    img: User64Img,
    txt: "Pańszczyzna",
    user: "Projekt edukacyjny",
    url: "//panszczyzna.netlify.app",
  },
  {
    img: User65Img,
    txt: "Anne Frank",
    user: "Projekt edukacyjny",
    url: "//anne-frank.netlify.app",
  },
  {
    img: User66Img,
    txt: "Złoto",
    user: "Projekt edukacyjny",
    url: "//zloto.netlify.app",
  },
  {
    img: User67Img,
    txt: "Maciej Glogier",
    user: "Projekt edukacyjny",
    url: "//glogier.netlify.app",
  },
  {
    img: User68Img,
    txt: "Dalajlama XIV",
    user: "Projekt edukacyjny",
    url: "//dalajlama.netlify.app",
  },
  {
    img: User69Img,
    txt: "Potop",
    user: "Projekt edukacyjny",
    url: "//potop.netlify.app",
  },
  {
    img: User70Img,
    txt: "Roger Penrose",
    user: "Projekt edukacyjny",
    url: "//roger-penrose.netlify.app",
  },
  {
    img: User71Img,
    txt: "Arka Przymierza",
    user: "Projekt edukacyjny",
    url: "//arka-przymierza.netlify.app",
  },
  {
    img: User72Img,
    txt: "Fryderyk Chopin",
    user: "Projekt edukacyjny",
    url: "//fryderyk-chopin.netlify.app",
  },
  {
    img: User73Img,
    txt: "Klub Pickwicka",
    user: "Projekt edukacyjny",
    url: "//pickwick.netlify.app",
  },
  {
    img: User74Img,
    txt: "Yehudi Menuhin",
    user: "Projekt edukacyjny",
    url: "//menuhin.netlify.app",
  },
  {
    img: User75Img,
    txt: "Jan Kowalewski",
    user: "Projekt edukacyjny",
    url: "//kowalewski.netlify.app",
  },
  {
    img: User76Img,
    txt: "Julia Zdanowska",
    user: "Protest antywojenny",
    url: "//zdanowska.netlify.app",
  },
  {
    img: User77Img,
    txt: "Wołodymyr Zełeński",
    user: "Nowożytny Leonidas - szkic",
    url: "//zelenski.netlify.app",
  },
  {
    img: User78Img,
    txt: "Zbrodnie Putina",
    user: "Protest antywojenny",
    url: "//zbrodnie-putina.netlify.app",
  },
  {
    img: User79Img,
    txt: "Ofiary Putina",
    user: "Protest antywojenny",
    url: "//ofiary-putina.netlify.app",
  },
  {
    img: User80Img,
    txt: "Stop Putin!",
    user: "Protest antywojenny",
    url: "//stop-putin.netlify.app",
  },
  {
    img: User81Img,
    txt: "Odkrycie Mateusza",
    user: "Projekt prywatny",
    url: "//krzyz-celtycki.netlify.app",
  },
  {
    img: User82Img,
    txt: "Skrzypek na dachu",
    user: "Projekt prywatny",
    url: "//skrzypek-na-dachu.netlify.app",
  },
  {
    img: User83Img,
    txt: "Król Edyp",
    user: "Projekt edukacyjny",
    url: "//edyp.netlify.app",
  },
  {
    img: User84Img,
    txt: "Konstytucja 3 Maja",
    user: "Projekt edukacyjny",
    url: "//vivat-maj.netlify.app",
  },
  {
    img: User85Img,
    txt: "Teofil Lenartowicz",
    user: "Projekt edukacyjny",
    url: "//mazurzyn.netlify.app",
  },
  {
    img: User86Img,
    txt: "Jerzy Trela",
    user: "Projekt edukacyjny",
    url: "//jerzy-trela.netlify.app",
  },
  {
    img: User87Img,
    txt: "Zespół Aspergera",
    user: "Projekt edukacyjny",
    url: "//asperger.netlify.app",
  },
  {
    img: User88Img,
    txt: "Męczennice elżbietańskie",
    user: "Projekt edukacyjny",
    url: "//elzbietanki.netlify.app",
  },
  {
    img: User89Img,
    txt: "Nataniel",
    user: "Projekt prywatny",
    url: "//nataniel.netlify.app",
  },
  {
    img: User90Img,
    txt: "Moja aktywność",
    user: "Projekt edukacyjny",
    url: "//aktywny.netlify.app",
  },
  {
    img: User91Img,
    txt: "Michio Kaku",
    user: "Projekt edukacyjny",
    url: "//michio-kaku.netlify.app",
  },
  {
    img: User92Img,
    txt: "Wołyń 1943-1945",
    user: "Projekt edukacyjny",
    url: "//wolyn.netlify.app",
  },
  {
    img: User93Img,
    txt: "Tomasz Stańko",
    user: "Projekt edukacyjny",
    url: "//tomasz-stanko.netlify.app",
  },
  {
    img: User94Img,
    txt: "Zbigniew Herbert",
    user: "Projekt edukacyjny",
    url: "//zbigniew-herbert.netlify.app",
  },
  {
    img: User95Img,
    txt: "Alan Turing",
    user: "Projekt edukacyjny",
    url: "//alan-mathison-turing.netlify.app",
  },
  {
    img: User96Img,
    txt: "Bóg Ojciec",
    user: "Projekt edukacyjny",
    url: "//bog-ojciec.netlify.app",
  },
  {
    img: User97Img,
    txt: "Jennifer Fulwiler",
    user: "Projekt edukacyjny",
    url: "//jennifer-fulwiler.netlify.app",
  },
  {
    img: User98Img,
    txt: "Królowa Elżbieta II",
    user: "Projekt edukacyjny",
    url: "//elzbieta.netlify.app",
  },
  {
    img: User99Img,
    txt: "Mieczysław Kosz",
    user: "Projekt edukacyjny",
    url: "//kosz.netlify.app",
  },
  {
    img: User100Img,
    txt: "William James Sidis",
    user: "Projekt edukacyjny",
    url: "//sidis.netlify.app",
  },
  {
    img: User101Img,
    txt: "Rodzina, ach rodzina",
    user: "Projekt prywatny",
    url: "//rodzinnie.netlify.app",
  },
  {
    img: User102Img,
    txt: "Bogumił Kobiela",
    user: "Projekt prywatny",
    url: "//kobiela.netlify.app",
  },
  {
    img: User103Img,
    txt: "Elementarz Falskiego",
    user: "Projekt prywatny",
    url: "//falski.netlify.app",
  },
  {
    img: User104Img,
    txt: "Korepetycje z matematyki",
    user: "RAF-EDU",
    url: "//korepetycje.netlify.app",
  },
  {
    img: User105Img,
    txt: "Ania",
    user: "Projekt prywatny",
    url: "//ania-z.netlify.app",
  },
  {
    img: User106Img,
    txt: "Habitat Nataniela",
    user: "Projekt prywatny",
    url: "//habitat-nat.netlify.app",
  },
  {
    img: User107Img,
    txt: "Blog o Natanielku",
    user: "Projekt prywatny",
    url: "//nataniel.onrender.com",
  },
  {
    img: User108Img,
    txt: "Fundacja 'wARTości'",
    user: "Projekt publiczny",
    url: "//fundacja.netlify.app",
  },
  {
    img: User109Img,
    txt: "Marek Niedźwiecki",
    user: "Projekt publiczny",
    url: "//marek-niedzwiecki.netlify.app/",
  },
  {
    img: User110Img,
    txt: "Natek",
    user: "Projekt prywatny",
    url: "//natek.netlify.app/",
  },
  {
    img: User111Img,
    txt: "Natko",
    user: "Projekt prywatny",
    url: "//natko.netlify.app/",
  },
  {
    img: User112Img,
    txt: "Wacław Dobrowolski",
    user: "Projekt edukacyjny",
    url: "//dobrowolski.netlify.app/",
  },
  {
    img: User113Img,
    txt: "Wynajem namiotów",
    user: "Firma eventowa",
    url: "//wynajem-namiotow.netlify.app/",
  },
  {
    img: User114Img,
    txt: "Antologia Proroków",
    user: "Projekt edukacyjny",
    url: "//antologia-prorokow.netlify.app/",
  },
  {
    img: User115Img,
    txt: "Rodzina Jacka",
    user: "Projekt prywatny",
    url: "//jacek.netlify.app/",
  },
  {
    img: User116Img,
    txt: "Aqua fitness 55+",
    user: "Projekt prywatny",
    url: "//aquafitness.netlify.app/",
  },
  {
    img: User117Img,
    txt: "Paweł Mosiołek",
    user: "Projekt oficjalny",
    url: "//pawelmosiolek.netlify.app/",
  },
  {
    img: User118Img,
    txt: "Grupa studencka 'EuroTrek'",
    user: "Projekt oficjalny",
    url: "//eurotrek.netlify.app/",
  },
  {
    img: User119Img,
    txt: "Teoria dr Nikodema Popławskiego",
    user: "Projekt prywatny",
    url: "//blackhole-universe.netlify.app",
  },
  {
    img: User120Img,
    txt: "Pralnia Super Pucuś",
    user: "Projekt firmowy",
    url: "//pranie-dywanow.j.pl",
  },
  {
    img: User121Img,
    txt: "Rody Gierczak i Ofiara",
    user: "Projekt prywatny",
    url: "//rodowekorzenie.netlify.app",
  },
  {
    img: User122Img,
    txt: "Zbigniew Rutkowski",
    user: "Projekt publiczny",
    url: "//zbigniew-rutkowski.netlify.app",
  },
  {
    img: User123Img,
    txt: "Zbuduj stronę w Replit",
    user: "Projekt publiczny",
    url: "//zbuduj-strone.netlify.app/",
  },
  {
    img: User124Img,
    txt: "Kwantowy Portal",
    user: "Projekt publiczny",
    url: "//kwanty.netlify.app/",
  },
  {
    img: User125Img,
    txt: "Interaktywana Akademia",
    user: "Projekt edukacyjny",
    url: "//inter-akademia.netlify.app/",
  },
  {
    img: User126Img,
    txt: "Michael Thonet",
    user: "Projekt edukacyjny",
    url: "//wizjoner.netlify.app/",
  },
  {
    img: User127Img,
    txt: "Wiersze Antypowabne",
    user: "Projekt prywatny",
    url: "//antypowabne.netlify.app/",
  },
  {
    img: User128Img,
    txt: "prof. Maciej Dunajski",
    user: "Projekt edukacyjny",
    url: "//dunajski.netlify.app/",
  },
  {
    img: User129Img,
    txt: "Stephen Hawking",
    user: "Projekt edukacyjny",
    url: "//odysejahawkinga.netlify.app/",
  },
  {
    img: User130Img,
    txt: "Aqua Senior",
    user: "Projekt edukacyjny",
    url: "//aqua-plus.netlify.app/",
  },
  {
    img: User131Img,
    txt: "Konstelacja Pasji",
    user: "Projekt autobiograficzny",
    url: "//konstelacjapasji.netlify.app/",
  },
  {
    img: User132Img,
    txt: "Niedzielne Światło",
    user: "Lekcjonarz mszalny",
    url: "//ewangelie.netlify.app/",
  },
  {
    img: User133Img,
    txt: "Math Mentor",
    user: "Korepetycje z matematyki",
    url: "//mathmentor-app.onrender.com/",
  },
  {
    img: User134Img,
    txt: "Święci Kościoła",
    user: "Święci Kościoła Katolickiego",
    url: "//lux-sanctorum.netlify.app/",
  },
  {
    img: User135Img,
    txt: "Kuchnia Polska",
    user: "Sekrety Kuchni Polskiej",
    url: "//kuchniapolska.netlify.app/",
  },
  {
    img: User136Img,
    txt: "Krzysztof Wielocha",
    user: "Sołtys, prezes OSP",
    url: "//krzysztofwielocha.netlify.app/",
  },
  {
    img: User137Img,
    txt: "Wspólnota charyzmatyczna",
    user: "Odnowa w Duchu Św.",
    url: "//surrexit-dominus.netlify.app/",
  },
  {
    img: User138Img,
    txt: "Projekt edukacyjny",
    user: "Irena Cichowska",
    url: "//cichowska.onrender.com/",
  },
  {
    img: User139Img,
    txt: "Projekt edukacyjny",
    user: "M-M-O-S",
    url: "//orsetti-skwarczynska.netlify.app/",
  },
  {
    img: User140Img,
    txt: "Projekt prywatny",
    user: "Julia Chabior",
    url: "//julia-chabior.netlify.app/",
  },
  {
    img: User141Img,
    txt: "Projekt edukacyjny",
    user: "Rzeczywistość",
    url: "//rzeczywistosc.netlify.app/",
  },
  {
    img: User142Img,
    txt: "Projekt edukacyjny",
    user: "Alexandru Proca",
    url: "//alexandru-proca.netlify.app/",
  },
  {
    img: User143Img,
    txt: "Projekt prywatny",
    user: "Matura 1975",
    url: "//klasab.netlify.app/",
  },
  {
    img: User144Img,
    txt: "Projekt edukacyjny",
    user: "Zbrodnia Wołyńska 1943",
    url: "//wolyn-zbrodnia.netlify.app/",
  },
  {
    img: User145Img,
    txt: "Pamiętnik autorski",
    user: "Lata dzieciństwa i młodości",
    url: "//wstrzasy.netlify.app/",
  },
  {
    img: User146Img,
    txt: "Bitwa pod Grunwaldem",
    user: "Projekt edukacyjny",
    url: "//grunwald1410.netlify.app/",
  },
  {
    img: User147Img,
    txt: "Szafarnia - młodość Chopina",
    user: "Projekt edukacyjny",
    url: "//szafarnia.netlify.app/",
  },
  {
    img: User148Img,
    txt: "Nauka pływania",
    user: "Projekt edukacyjny",
    url: "//naukaplywania.netlify.app/",
  },
  {
    img: User149Img,
    txt: "Nowe horyzonty sztuki cyfrowej",
    user: "Projekt innowacyjny",
    url: "//niezdecydowanie.netlify.app/",
  },
  {
    img: User150Img,
    txt: "Matka Boża",
    user: "Projekt religijny",
    url: "//maryja-cicha-obecnosc.netlify.app/",
  },
  {
    img: User151Img,
    txt: "Piórkiem, węglem i kotletem",
    user: "Projekt wspomnieniowy",
    url: "//zin-i-kotlet.netlify.app/",
  },
  {
    img: User152Img,
    txt: "EM-FIT Ewa Minda",
    user: "Projekt edukacyjny",
    url: "//em-fit.netlify.app/",
  },
  {
    img: User153Img,
    txt: "Samouczek tańca - Szuraniec",
    user: "Projekt edukacyjny",
    url: "//dwanajeden.netlify.app/",
  },
  {
    img: User154Img,
    txt: "Pierwsza Pomoc",
    user: "Projekt edukacyjny",
    url: "//lifeline-command.netlify.app/",
  },
  {
    img: User155Img,
    txt: "Pilates",
    user: "Projekt firmowy",
    url: "//natalia-gocol.netlify.app/",
  },
  {
    img: User156Img,
    txt: "Trener Personalny",
    user: "Projekt szkoleniowy",
    url: "//pulsemotion-firetv.netlify.app/",
  },
];
